import React from 'react'
import { Formik, Form } from 'formik';
import { MainInput, SubmitButton } from '../../components';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../application/utils/Routes';
import services from '../../../ioc/services';
import { useDispatch, useSelector } from 'react-redux';
import { SET_SETLOGGEDINUSER_DETAILS, logUserIn, setLoggedInUserDetails } from '../../../application/store/actions/user';
import { useState } from 'react';
import { getFormSubmittingState } from '../../../application/store/selectors/ui';
import { setFormSubmitting } from '../../../application/store/actions/ui';
import { useEffect } from 'react';
import { getIsUserLoggedIn } from '../../../application/store/selectors/user';

function ResetPasswordEmail() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isFormSubmiting = useSelector(getFormSubmittingState);
    const isUserLoggedIn = useSelector(getIsUserLoggedIn);

    useEffect(() => {
        if (isUserLoggedIn) navigate(ROUTES.DASHBOARD);

    }, [isUserLoggedIn, isFormSubmiting])

    const isEmpty = value => value.trim() == "";

    return (
        <div className="w-full max-w-lg">
            <Formik
                initialValues={{}}
                enableReinitialize
                onSubmit={async (values) => {
                    if (isEmpty(values.email)) {
                        services.alert.toast.error("Please Enter Your Email")
                        return
                    }
                    
                    dispatch(setFormSubmitting(true))

                    services.api.auth.passwordResetEmail(values).then(res => {
                        services.alert.toast.success("Password Reset Email Sent Successfully")
                    })
                    .catch(err=>{
                        services.alert.toast.error(err);
                    })
                    .finally(()=>{
                        dispatch(setFormSubmitting(false))
                    })

                }}>
                <Form className="flex flex-col gap-7">
                    <MainInput label="Email Address" name="email" type="email" placeholder="User@username.com" />
                    <SubmitButton text="Send Email" disabled={isFormSubmiting} />
                </Form>

            </Formik>



        </div>
    )
}

export default ResetPasswordEmail